import { OBJECT_TYPE } from "../constants/object-type";
import * as _ from 'lodash';

export function calculateCrumbs(ctrl, lCrumb: any, data: any, newCrumbs: any[]) {
  if (!data) {
    return;
  }
  const crumbSpec = typeof lCrumb === 'string' ? {type: lCrumb} : lCrumb;
  if (!crumbSpec || !crumbSpec.type) {
    return;
  }
  const crumbObjType = OBJECT_TYPE[crumbSpec.type];
  if (!crumbObjType) {
    return;
  }
  let crumbData: any;
  if (typeof crumbSpec.resolve === 'function') {
    crumbData = crumbSpec.resolve(data);
  } else {
    crumbData = (data as any)[crumbObjType.apiParam];
  }
  if (!crumbData || !(crumbData as any).id) {
    return;
  }
  const crumb = updateCrumb(ctrl, crumbObjType, crumbData, crumbSpec.labelOverride);
  if (crumb) {
    newCrumbs.push(crumb);
  }
}

export function updateCrumb(ctrl, crumbObjType: any, data: any, labelOverride?: string) {
  const crumbObj = data || {};
  if (ctrl.perms[crumbObjType.hidePerm] === true) {
    return;
  }

  const permsFromObject = _.isArray(crumbObjType.perm) ? crumbObjType.perm : crumbObjType.perm ? [crumbObjType.perm] : null;
  const perm = !crumbObjType.sectionPerm && permsFromObject ? _.find(permsFromObject, function(pm) {
    return ctrl.perms[pm];
  })  : true;
  return {
    id: crumbObj.id,
    name: crumbObj.name || crumbObj.fileName || "undefined",
    obj: crumbObj,
    objectType: crumbObjType,
    perm: perm,
    labelOverride: labelOverride
  };
}